/**
 * Shared styling for section Submit buttons.
 *
 * When a `submitColor` is provided (e.g. when a section is embedded in the NewRx
 * workflow and the Submit button needs to stand out), the button renders filled in
 * that color; otherwise it falls back to the plain outlined button the standalone
 * pages use. Keeps the embedded-button look in one place so it cannot drift across
 * the CCS / RPH / Order sections that reuse it.
 */
export const getSubmitButtonProps = (submitColor?: string) => ({
    variant: (submitColor ? "contained" : "outlined") as "contained" | "outlined",
    color: "default" as const,
    style: submitColor
        ? { backgroundColor: submitColor, color: "#000", fontWeight: 600 }
        : undefined,
});
